$(function () {
  let YouTubeContainers = document.querySelectorAll(".embed-youtube");

  for (let i = 0; i < YouTubeContainers.length; i++) {
    let container = YouTubeContainers[i];
    let videoThumbnail = container.dataset.videoId;
    // A title the editor saved as empty formatting (`<p>&nbsp;</p>`) arrives as whitespace or a bare entity.
    let videoTitle = (container.dataset.videoTitle || "").replace(/&nbsp;|\u00a0/g, " ").trim() || "YouTube";
    let playButton = container.querySelector(".embed-youtube-play");
    if (playButton) {
      playButton.setAttribute("aria-label", videoTitle);
    }
    let imageSource = "https://img.youtube.com/vi/" + videoThumbnail.replace(/\//g, "") + "/sddefault.jpg";
    let image = new Image();
    image.addEventListener("load", function () {
      // A thumbnail that arrives after the video was started would paint over the player.
      if (container.querySelector(".embed-youtube-play")) {
        container.appendChild(image);
      }
    });
    // The play button carries the video's name, so the thumbnail behind it is decorative.
    image.alt = "";
    image.src = imageSource;

    container.addEventListener("click", function () {
      let iframe = document.createElement("iframe");
      iframe.classList.add("youtube-player");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute(
        "allow",
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      );
      iframe.setAttribute("referrerpolicy", "no-referrer-when-downgrade");
      iframe.setAttribute("title", videoTitle);
      iframe.setAttribute(
        "src",
        "https://www.youtube.com/embed/" + this.dataset.videoId + "?rel=0&showinfo=0&autoplay=1",
      );

      this.innerHTML = iframe.outerHTML;
      // Replacing the play button removes the focused element, so keyboard users continue inside the player.
      this.querySelector("iframe").focus();
    });
  }
});
